<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-05-20 10:22:53
 * @LastEditTime: 2021-06-16 16:49:43
 * @LastEditors: JDY
-->
<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form :form="form">
        <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['title', { rules: [{ required: true, message: '请输入名称' }] }]"
            name="title"
            placeholder="请输入名称"
          />
        </a-form-item>

        <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            rows="4"
            name="desc"
            placeholder="请输入简介"
            v-decorator="['desc', { rules: [{ required: true, message: '请输入简介' }] }]"
          />
        </a-form-item>
        <a-form-item label="分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            placeholder="请选择分类"
            name="type"
            optionFilterProp="children"
            allow-clear
            v-decorator="['type', { rules: [{ required: true, message: '请选择分类' }] }]"
          >
            <a-select-option v-for="(value, key) in typeList" :key="Number(key)">{{
              value
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" help="是否在前端展示，默认展示">
          <a-switch
            checked-children="展示"
            un-checked-children="隐藏"
            name="state"
            v-decorator="[
              'state',
              {
                valuePropName: 'checked',
                initialValue: true
              }
            ]"
          />
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-button :loading="formLoading" @click="handleSubmit(setFormData)" type="primary">提交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { GoBack } from '@/components'
import { form, select } from '@/mixins'

const fields = ['title', 'desc', 'type', 'state']
const apiList = {
    getInfo: '/exams/',
    create: '/exams/create',
    update: '/exams/'
}
export default {
    name: 'ExamForm',
    mixins: [form, select],
    components: {
        GoBack
    },
    data () {
        return {
            fields,
            apiList,
            typeList: ['问答', '问卷调查']
        }
    },
    mounted () {
        if (this.$route.params.id) {
            this.getFormData(this.$route.params.id, function (values) {
                values.state = values.state === 1
            }) // 获取编辑信息
        }
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-04-28 15:51:55
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description: 整理表单数据
         * @param  {*}
         * @return {*}
         * @param {*} values
         */
        setFormData (values) {
            values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
        }
    }
}
</script>
